import type { PlatformCapabilities } from '@localagent/platform';

export class WebPlatform implements PlatformCapabilities {
  readonly type = 'web' as const;
  readonly osPlatform = 'web';
  readonly supportsLocalDirectories = false;

  // No bootstrap channel: its absence IS the web arm. The SDK's browser
  // resolver owns the address (sdk ADR-008, la ADR-8588f).

  async selectDirectory(): Promise<string | null> {
    return null;
  }

  async syncBridgeContext(): Promise<void> {
    // No bridge connection in web mode
  }
}
